(() => {
  'use strict';

  const leafSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M20.8 2.9c-6.6.1-11.7 1.6-14.7 4.6-3.2 3.2-2.7 7.4.1 9.8 2.8 2.5 7.1 2.1 10.1-.9 2.9-2.9 4.3-7.9 4.5-14.5ZM3.2 21c3.3-4 7.7-7.2 13.9-10.6"/></svg>';
  const leafSpecs = [
    [47, 28, -52, -41, -92, 0, '#c6ff39'],
    [60, 23, 43, -35, 78, 90, '#b77b2d'],
    [68, 39, 57, 9, 110, 30, '#c6ff39'],
    [42, 45, -54, 6, -75, 120, '#d6a142'],
    [53, 57, -37, 42, 65, 60, '#c6ff39'],
    [72, 58, 42, 49, 120, 150, '#b77b2d'],
    [61, 71, 16, 44, -60, 180, '#c6ff39']
  ];
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches || Boolean(navigator.connection?.saveData);

  function addLiveStatus(parent) {
    const status = document.createElement('span');
    status.className = 'gos-autumn-easter__sr-only';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    parent.append(status);
    return status;
  }

  function initMascot() {
    const slide = document.querySelector('.gos-campaign__slide--promo');
    const art = slide?.querySelector('.gos-campaign__art');
    const image = art?.querySelector('img');
    if (!slide || !art || !image || slide.dataset.gosAutumnEaster) return;
    slide.dataset.gosAutumnEaster = 'v1';
    const listeners = new AbortController();
    const { signal } = listeners;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'gos-autumn-easter__mascot';
    button.setAttribute('aria-label', 'Осенний маскот: показать секрет');
    button.setAttribute('aria-describedby', 'gos-autumn-mascot-hint');
    const hint = document.createElement('span');
    hint.id = 'gos-autumn-mascot-hint';
    hint.className = 'gos-autumn-easter__sr-only';
    hint.textContent = 'Нажмите, чтобы увидеть короткую осеннюю анимацию.';
    slide.append(button, hint);
    const status = addLiveStatus(slide);

    // The published art is aria-hidden. The button is its sibling, with its hit
    // area fitted to the mascot's head and torso in the square source image.
    function placeButton() {
      const imageBox = image.getBoundingClientRect();
      const slideBox = slide.getBoundingClientRect();
      const side = Math.min(imageBox.width, imageBox.height);
      const left = imageBox.left + (imageBox.width - side) / 2 - slideBox.left;
      const top = imageBox.top + (imageBox.height - side) / 2 - slideBox.top;
      button.style.left = `${left + side * .39}px`;
      button.style.top = `${top + side * .04}px`;
      button.style.width = `${side * .36}px`;
      button.style.height = `${side * .74}px`;
    }
    placeButton();
    image.addEventListener('load', placeButton, { once: true, signal });
    window.addEventListener('resize', placeButton, { passive: true, signal });
    let observer;
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(placeButton);
      observer.observe(art);
    }

    let lastPlayed = -Infinity;
    let cleanupTimer = 0;
    button.addEventListener('click', () => {
      const now = Date.now();
      if (now - lastPlayed < 3000) return;
      lastPlayed = now;
      window.clearTimeout(cleanupTimer);
      art.querySelector('.gos-autumn-easter__leaf-field')?.remove();
      art.querySelector('.gos-autumn-easter__mascot-note')?.remove();

      if (!reduced()) {
        const field = document.createElement('span');
        field.className = 'gos-autumn-easter__leaf-field';
        field.setAttribute('aria-hidden', 'true');
        leafSpecs.forEach(([x, y, dx, dy, turn, delay, color]) => {
          const leaf = document.createElement('span');
          leaf.className = 'gos-autumn-easter__leaf';
          leaf.style.setProperty('--leaf-x', `${x}%`);
          leaf.style.setProperty('--leaf-y', `${y}%`);
          leaf.style.setProperty('--leaf-dx', `${dx}px`);
          leaf.style.setProperty('--leaf-dy', `${dy}px`);
          leaf.style.setProperty('--leaf-turn', `${turn}deg`);
          leaf.style.setProperty('--leaf-delay', `${delay}ms`);
          leaf.style.setProperty('--leaf-color', color);
          leaf.innerHTML = leafSvg;
          field.append(leaf);
        });
        art.append(field);
      }
      const note = document.createElement('span');
      note.className = 'gos-autumn-easter__mascot-note';
      note.textContent = 'Осень с характером.';
      art.append(note);
      status.textContent = note.textContent;
      cleanupTimer = window.setTimeout(() => {
        art.querySelector('.gos-autumn-easter__leaf-field')?.remove();
        note.remove();
        status.textContent = '';
      }, 2200);
    }, { signal });
    function cleanup() {
      listeners.abort();
      observer?.disconnect();
      window.clearTimeout(cleanupTimer);
      art.querySelector('.gos-autumn-easter__leaf-field')?.remove();
      art.querySelector('.gos-autumn-easter__mascot-note')?.remove();
      button.remove();
      hint.remove();
      status.remove();
      delete slide.dataset.gosAutumnEaster;
    }
    function onSectionUnload(event) {
      if (!event.target.contains(slide)) return;
      cleanup();
    }
    document.addEventListener('shopify:section:unload', onSectionUnload, { signal });
    window.addEventListener('pagehide', cleanup, { once: true, signal });
  }

  function initSince() {
    const header = document.querySelector('.gos-reputation-header');
    const inner = header?.querySelector('.gos-reputation-header__inner');
    const strong = inner?.querySelector(':scope > strong');
    const image = inner?.querySelector(':scope > img');
    if (!header || !strong || !image || header.dataset.gosAutumnEaster) return;
    header.dataset.gosAutumnEaster = 'v1';

    const eyes = document.createElement('span');
    eyes.className = 'gos-autumn-easter__eyes';
    image.before(eyes);
    eyes.append(image);
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'gos-autumn-easter__since';
    button.textContent = strong.textContent;
    button.setAttribute('aria-label', 'SINCE 2009: нажмите трижды для осеннего секрета');
    strong.replaceWith(button);
    const status = addLiveStatus(header);

    let presses = 0;
    let lastPress = -Infinity;
    let lastReveal = -Infinity;
    let noteTimer = 0;
    let winkTimer = 0;
    button.addEventListener('click', () => {
      const now = Date.now();
      if (now - lastReveal < 5000) return;
      presses = now - lastPress > 3000 ? 1 : presses + 1;
      lastPress = now;
      if (presses < 3) return;
      presses = 0;
      lastReveal = now;
      window.clearTimeout(noteTimer);
      window.clearTimeout(winkTimer);
      header.querySelector('.gos-autumn-easter__header-note')?.remove();

      const note = document.createElement('span');
      note.className = 'gos-autumn-easter__header-note';
      note.setAttribute('aria-hidden', 'true');
      note.innerHTML = `${leafSvg}<span>С 2009. Каждая осень — новый ход.</span>`;
      header.append(note);
      status.textContent = 'С 2009. Каждая осень — новый ход.';
      if (!reduced()) {
        eyes.classList.add('is-winking');
        winkTimer = window.setTimeout(() => eyes.classList.remove('is-winking'), 500);
      }
      noteTimer = window.setTimeout(() => {
        note.remove();
        status.textContent = '';
      }, 3000);
    });
    window.addEventListener('pagehide', () => {
      window.clearTimeout(noteTimer);
      window.clearTimeout(winkTimer);
      eyes.classList.remove('is-winking');
      header.querySelector('.gos-autumn-easter__header-note')?.remove();
      status.textContent = '';
    });
  }

  function init() {
    initMascot();
    initSince();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
})();
